import React, { useEffect, useState } from "react";
import { loadGapiInsideDOM, loadAuth2 } from "gapi-script";
import { actionGoogleLogin } from "../api/postApi";
import { MD5 } from "crypto-js";
import Cookies from "js-cookie";
import { InitializeApi } from "../api/initializeApi";
import { useDispatch } from "react-redux";
import { loading, notice } from "../redux/action/action";

export const CheckGoogleLogin = (dispatch) => async () => {
  let gapi = null;
  let user = null;

  try {
    gapi = await loadGapiInsideDOM();

    const auth2 = await loadAuth2(
      gapi,
      "307325716994-3rhn5npsg507np0ni4m6e69hacigm6hq.apps.googleusercontent.com",
      "profile"
    );

    if (auth2.isSignedIn.get()) {
      user = auth2.currentUser.get();
      const profile = user.getBasicProfile();
      const userId = user.getId();

      const userDetails = {
        name: profile.getName(),
        profileImg: profile.getImageUrl(),
        email: profile.getEmail(),
        userId: userId,
      };

      const randomNumber = Math.random().toString().slice(2, 14);
      await actionGoogleLogin({
        user_id: userId,
        emailAddress: userDetails.email,
        unlimit_code: "",
        invite: "",
        s_auth: randomNumber,
        r_auth: MD5(`Tgs${randomNumber}mov9191Login`).toString(),
      })
        .then((data) => {
          if (Cookies.get("token")) {
            Cookies.remove("token");
          }
          Cookies.set("token", data.token, { expires: 3 });
        })
        .catch((err) => {});
    } else {
    }
  } catch (error) {}
};
